import { render, staticRenderFns } from "./ResultJapanese.vue?vue&type=template&id=34a12c9e&scoped=true&lang=pug&"
import script from "./ResultJapanese.vue?vue&type=script&lang=ts&"
export * from "./ResultJapanese.vue?vue&type=script&lang=ts&"
import style0 from "./ResultJapanese.vue?vue&type=style&index=0&id=34a12c9e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a12c9e",
  null
  
)

export default component.exports